var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "131px",
    height: "106px",
    viewBox: "0 0 131 106",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_white",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-39",
    transform: "translate(12.000000, 16.000000)",
    strokeWidth: 16.3476923
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,72.4669231 L52.2318841,0",
    id: "Line-10",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.10416667,74.69 L105.551432,74.69",
    id: "Line-10",
    stroke: "#FBC02D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2318841,0 L105.551432,74.69",
    id: "Line-10",
    stroke: "#FF5252"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d0e27845d17504d0b67a493137fd8380.svg";
export { ForwardRef as ReactComponent };